import BasicService from "./BasicService";

class HistoryService extends BasicService {
  constructor() {
    super();
  }

  getHistory(fromDate, toDate) {
    let url = `/history`;
    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate
        }
      })
      .then(request => request.data);
  }
  getHistoryByRest(restId) {
    let url = `/history/rest/${restId}`;
    return this.axios
      .get(url)
      .then(request => request.data);
  }
  getHistoryByUser(userId) {
    let url = `/history/user/${userId}`;
    return this.axios
      .get(url)
      .then(request => request.data);
  }
  getHistoryByCompany() {
    let url = `/history/company`;
    return this.axios
      .get(url)
      .then(request => request.data);
  }
  getHistoryByItemId(orderId) {
    let url = `/history/order/${orderId}`;
    return this.axios
      .get(url)
      .then(request => request.data);
  }
}

const assignService = new HistoryService();
export default assignService;
